import { ReportHandler } from 'web-vitals';
import { trackWebVitals } from './utils/analytics';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  // Always track web vitals to GA4
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(trackWebVitals);
    getFID(trackWebVitals);
    getFCP(trackWebVitals);
    getLCP(trackWebVitals);
    getTTFB(trackWebVitals);

    // Also call custom handler if provided
    if (onPerfEntry && onPerfEntry instanceof Function) {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    }
  });
};

export default reportWebVitals;
